// Angular
import { Component, HostBinding, OnDestroy, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';

// Libraries
import { Observable, takeUntil } from 'rxjs';
import { Select } from '@ngxs/store';

// Helpers
import { AssetHelper } from '../../../../shared/helpers/asset.helper';

// Enums
import { TenantTitleType } from '../../../../shared/enums/tenant-name.enum';

// Configs
import { LayoutConfig } from '../../../../shared/config/layout.config';

// Store
import { AuthState } from '../../state/auth.state';

// Models
import { AppCleanup } from '../../../../shared/models';

@Component({
	selector: 'auth-base',
	templateUrl: './auth-base.component.html',
	styleUrls: ['./auth-base.component.scss'],
})
export class AuthBaseComponent extends AppCleanup implements OnInit, OnDestroy {
	@HostBinding('class') classes = 'component-container';
	today: number = Date.now();
	headerLogo: HTMLImageElement;
	coilTruck: string = '../../assets/images/auth-image.png';
	backgroundImage: string = '../../assets/images/background-1.jpg';
	favicon: HTMLLinkElement;
	@Select(AuthState.isLoggedIn) isLoggedIn$: Observable<boolean>;

	constructor(
		private titleService: Title,
		private router: Router
	) {
		super();
	}

	ngOnInit() {
		this.headerLogo = document.querySelector('#headerLogo'); // Setting header logo variable
		this.setHeaderLogo(); // Setting header logo to correct src based on domain
		this.titleService.setTitle(TenantTitleType.GENERIC);
		this.favicon = document.querySelector('#favicon'); // Setting favicon variable

		if (this.favicon) {
			this.favicon.href = new LayoutConfig().defaultFavicon;
		}

		return this.isLoggedIn$.pipe(takeUntil(this.destroy)).subscribe((loggedIn) => {
			if (loggedIn || this.isViewer) {
				this.router.navigate(['/']);
			}
		});
	}

	ngOnDestroy() {
		super.ngOnDestroy();
	}

	setHeaderLogo() {
		if (this.headerLogo) {
			this.headerLogo.src = new AssetHelper().getLogoByDomain();
		}
	}
}
